import axios from '@_system/axios/axios.js'
export default {
	path: '/goods',

	updatesupplierprice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatesupplierprice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	push(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/push', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getStatic(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getStatic/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getBaseData(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getBaseData', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	saveResultData(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveResultData', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getInventory(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getInventory/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getInventoryquantityadjustbill(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getInventoryquantityadjustbill/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getonlineinfo(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getonlineinfo/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getgoodsidbygroupcode(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getgoodsidbygroupcode/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	autoSplitOrder(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/autoSplitOrder/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},		
	getEmergentGoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getEmergentGoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	getgoodscodebygroupcode(data = {}){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getgoodscodebygroupcode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
		
	getmaterial(data = {}){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getmaterial', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	getcargoname(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getcargoname', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	listgoodsspu(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listgoodsspu', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	updategoodsspu(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updategoodsspu', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	updatestock(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatestock', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},		
	grabCatagories(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/grabCatagories', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getdistributionprice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getdistributionprice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	}
	
	
}
